import {SafeAndSecurePanel} from '@wr/ui-patterns';
import PropTypes from 'prop-types';
import React from 'react';

import PaymentFormHeader from '../PaymentFormHeader';

const PaymentFormTemplate = ({
    children,
    translations,
    cancellationUrl,
    paymentMethods,
    title,
    payWithSavedCard,
    setCybersourceVisibility,
    hasSavedCreditCards
}) => (
    <section className="app-container paymentform-template">
        <div className="flex-row">
            <div className="flex-column column-1-2 main-column">
                <PaymentFormHeader
                    cancellationUrl={cancellationUrl}
                    paymentMethods={paymentMethods}
                    title={title}
                    payWithSavedCard={payWithSavedCard}
                    setCybersourceVisibility={setCybersourceVisibility}
                    hasSavedCreditCards={hasSavedCreditCards}
                />
                {children}
                <SafeAndSecurePanel safeAndSecureMessage={translations.safeAndSecure.label} />
            </div>
        </div>
    </section>
);

PaymentFormTemplate.propTypes = {
    children: PropTypes.node.isRequired,
    translations: PropTypes.shape({
        safeAndSecure: PropTypes.shape({
            label: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    cancellationUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    hasSavedCreditCards: PropTypes.bool,
    paymentMethods: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        logo: PropTypes.string
    }))
};

PaymentFormTemplate.defaultProps = {
    paymentMethods: [],
    hasSavedCreditCards: false
};


export default PaymentFormTemplate;
